import styled from 'styled-components'

type ShapesProps = {
  source: string
  top?: string
  left?: string
}

export const Shapes = styled.div<ShapesProps>`
  pointer-events: none;
  position: absolute;
  width: 100%;
  height: 100%;
  top: ${({ top = '0px' }) => top};
  left: ${({ left = '0px' }) => left};
  background: black;
  z-index: -1;

  &::before {
    content: '';
    position: absolute;
    width: 100%;
    height: 100%;
    opacity: 0.66;
    background: url(${({ source }) => source}) center no-repeat no-repeat;
    pointer-events: none;
  }

  &::after {
    content: '';
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    background-image: linear-gradient(225deg, #00ff99 0%, #9933ff 100%);
    mix-blend-mode: multiply;
    opacity: 1;
    pointer-events: none;
  }

  @supports not (mix-blend-mode: multiply) {
    display: none;
  }
`
